export default __webpack_public_path__ + "static/media/Assign_Schemas.569d2b55.png";